<template>
  <v-container>
    <v-card>
      <v-container>
        <h2 class="text-lg-center text-md-center text-sm-center earth-color">You are now a member.</h2>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'success-membership',
  data () {
    return {}
  }
}
</script>

<style scoped>

</style>
